import React, { useEffect, useState } from "react";
import { InvoiceListType } from "../../redux/invoicing/invoicingTypes";
import {
  CommonHeader,
  Loader,
  ErrorSuccessModal,
} from "../../components/commons";
import AkTable from "../AkTable";
import InvoiceDetailCard from "./InvoiceDetailCard";
import FileSaver from "file-saver";
import moment from "moment";
// import { RevenueInvoiceList, ExpenseInvoiceList } from '../../components/Invoicing';
import { connect } from "react-redux";
import { RootState } from "../../redux/rootReducers";
import {
  GetClientColumnPayload,
  GetInoviceListTypePayload,
} from "../../commonTypes/invoicingTypes";
import {
  getIndividualClientColumnAction,
  getExpensesInvoiceListAction,
  getRevenueInvoiceListAction,
  resetInvoiceStatusCode,
  resetInvoicingError,
  resetInvoicingSuccess,
  deleteInvoiceAction,
} from "../../redux/invoicing";
import { downloadInvoice as downloadInvoiceApi } from "../../apis/invoicingApis";
import { resetSession } from "../../redux/auth";
import {
  INVOICE_REVENUE_HEADER,
  PAGINATION_INITIAL,
} from "../../constant/invoiceListConst";
import { useMenuCheck } from "../../customHooks/useMenuCheck";

type AppProps = {
  revenueInvoiceList?: any;
  client_code?: any;
  history?: any;
  token: string | null;
  fetching: boolean;
  success: number | null;
  error: string | null;
  company_name: string;
  statusCode: number | null;
  dispatchDeleteInvoice: Function;
  dispatchResetSession: () => void;
  dispatchResetInvoiceStatusCode: () => void;
  dispatchResetInvoicingError: () => void;
  dispatchResetInvoicingSuccess: () => void;
  dispatchGetRevenueInvoiceListAction: (
    data: GetInoviceListTypePayload
  ) => void;
  loginData: any;
};

const RevenueInvoiceList = ({
  history,
  token,
  fetching,
  client_code,
  success,
  error,
  statusCode,
  revenueInvoiceList,
  dispatchGetRevenueInvoiceListAction,
  dispatchResetSession,
  dispatchResetInvoicingSuccess,
  dispatchResetInvoiceStatusCode,
  dispatchDeleteInvoice,
  loginData,
  dispatchResetInvoicingError,
  company_name,
}: AppProps) => {
  const urlHref = window.location.pathname.split("/");
  let clientCodeFromUrl = urlHref && urlHref[urlHref.length - 1];
  const clientCodeUrl = clientCodeFromUrl ? clientCodeFromUrl : client_code;

  const [pagination, setPagination] = useState(PAGINATION_INITIAL);
  const [searchData, setSearchData] = useState("");

   
  	//========== User Management ==========//
	const [isEditInReveneueInvoicePresent, setIsEditInReveneueInvoicePresent] = useMenuCheck();
	//====================//

  useEffect(() => {
    const { location: { search = "" } = {} } = window;

    if (token && search === "") {
      let offset = 0,
        limit = 10;
      let finalData = {
        token,
        client_code: clientCodeUrl,
        offset,
        limit,
      };
      setIsEditInReveneueInvoicePresent("Edit Revenue","menu")
      dispatchGetRevenueInvoiceListAction(finalData);
    }
    dispatchResetInvoicingError();
    dispatchResetInvoicingSuccess();
  }, []);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchData && searchData.length >= 3) {
        fetchNewData(0, 10, searchData);
        setPagination(PAGINATION_INITIAL);
      }
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchData]);

  const handleSearch = (e: any) => {
    let value = e.target.value;
    setSearchData(value);

    if (value?.length === 0) {
      let finalData = {
        token,
        client_code: clientCodeUrl,
        offset: 0,
        limit: 10,
      };

      dispatchGetRevenueInvoiceListAction(finalData);
    }
  };

  // const handleSearch = (e: any) => {
  //     let value = e.target.value
  //     setSearchData(value)
  //     if (value && value.length >= 3) {
  //         fetchNewData(0, 10, value)
  //         setPagination(PAGINATION_INITIAL)
  //     }
  //     else if (value.length === 0) {
  //         fetchNewData(0, 10, "")
  //         setPagination(PAGINATION_INITIAL)
  //     }
  // }

  const fetchNewData = (offset: any, limit: any, search_term = "") => {
    if (token) {
      let finalData = {
        token,
        client_code: clientCodeUrl,
        offset,
        limit,
        search_term: search_term
          ? search_term
          : searchData && searchData.length >= 3
          ? searchData
          : "",
      };
      dispatchGetRevenueInvoiceListAction(finalData);
    }
    dispatchResetInvoicingError();
    dispatchResetInvoicingSuccess();
  };

  const deleteInvoice = (invoice_id: any) => {
    let data = {
      invoice_id,
      type: "revenue",
      token,
    };
    dispatchDeleteInvoice(data);
  };

  const editInvoice = (invoice_id: any) => {
    const type = "revenue";
    if (clientCodeUrl && type && invoice_id) {
      history.push({
        pathname: `/invoice/edit-invoice/${clientCodeUrl}?type=${type}&invoice_id=${invoice_id}`,
        state: {
          client_code: clientCodeUrl,
          type,
          invoice_id,
        },
      });
    }
  };

  const downloadInvoice = (params: any) => {
    params["token"] = token;
    let reportName = company_name
      ? company_name +
        "_revenue_" +
        moment(Date.now()).format("DD-MM-YYYY") +
        ".csv"
      : "report";
    downloadInvoiceApi(params).then((response) => {
      let blob = new Blob([response.data], { type: "text/csv;charset=utf-8" });
      FileSaver.saveAs(blob, reportName);
    });
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="Logout"
            onPress={() => {
              dispatchResetSession();
              dispatchResetInvoicingError();
            }}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => dispatchResetInvoicingError()}
          />
        );
      }
    }

    if (success === 1) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message="Invoice Deleted Successfully."
          buttonText="OK"
          onPress={() => {
            //fetchNewData(0, 10);
            window.location.reload();
            dispatchResetInvoicingSuccess();
          }}
          statusCode={statusCode}
        />
      );
    }
    return false;
  };

  const updatePagination = (data: any) => {
    setPagination(data);
  };
  return (
    <>
      {revenueInvoiceList && revenueInvoiceList.data ? (
        <AkTable
          data={revenueInvoiceList.data}
          count={revenueInvoiceList.total_count}
          fetchNewData={fetchNewData}
          editInvoice={isEditInReveneueInvoicePresent && editInvoice}
          deleteInvoice={deleteInvoice}
          fetching={fetching}
          type="revenue"
          client_code={clientCodeUrl}
          history={history}
          tableHeader={INVOICE_REVENUE_HEADER}
          loginData={loginData}
          downloadInvoice={downloadInvoice}
          handleSearch={handleSearch}
          pagination={pagination}
          updatePagination={updatePagination}
        />
      ) : null}
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.invoicing.fetching,
  success: state.invoicing.success,
  error: state.invoicing.error,
  statusCode: state.invoicing.statusCode,
  revenueInvoiceList: state.invoicing.revenueInvoiceList,
  loginData: state.auth.loginData,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetInvoiceStatusCode: () => dispatch(resetInvoiceStatusCode()),
  dispatchResetInvoicingError: () => dispatch(resetInvoicingError()),
  dispatchResetInvoicingSuccess: () => dispatch(resetInvoicingSuccess()),
  dispatchDeleteInvoice: (data: any) => dispatch(deleteInvoiceAction(data)),
  dispatchGetRevenueInvoiceListAction: (data: GetInoviceListTypePayload) =>
    dispatch(getRevenueInvoiceListAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RevenueInvoiceList);
